var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showGG)?_c('div',{staticClass:"gonggao"},[_c('div',[_c('div',{staticClass:"GGContent",on:{"click":_vm.goActie}},[_vm._m(0),_vm._m(1)])])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/images/images/GongGao.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('span',[_vm._v("1条新通知")])])
}]

export { render, staticRenderFns }